import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { Skeleton } from '@nike/eds';
import { getAccessToken } from '../../clientAPI';
import { LOCAL_STORAGE_KEY } from '../../constants';
import { saveAccessTokenToLocalStorage } from '../../utils/authHelpers';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get('code') as string;
  const [hasApiError, setHasApiError] = useState(false);

  const getAndSaveAccessToken = useCallback(async () => {
    if (code) {
      try {
        const data = await getAccessToken(
          code,
          process.env.REACT_APP_OKTA_REDIRECT_URL || '',
        );
        saveAccessTokenToLocalStorage(data.access_token, data.expires_in);
        let loc = '/';
        if (window.localStorage && window.location) {
          loc =
            localStorage.getItem(LOCAL_STORAGE_KEY.LOCATION_BEFORE_AUTH) || loc;
        }
        navigate(loc);
        return data;
      } catch (err) {
        console.log(err);
        setHasApiError(true);
      }
    }
  }, [code]);

  useEffect(() => {
    getAndSaveAccessToken();
  }, [getAndSaveAccessToken]);

  if (searchParams.get('error') || hasApiError) {
    return (
      <section className='tw-bg-white dark:tw-bg-gray-900'>
        <div className='tw-container tw-flex tw-items-center tw-min-h-screen tw-px-6 tw-py-12 tw-mx-auto'>
          <div>
            <h1 className='tw-mt-3 tw-text-2xl tw-font-semibold tw-text-gray-800 dark:tw-text-white md:tw-text-3xl'>
              Oops!
            </h1>
            <p className='tw-text-sm tw-font-medium tw-text-blue-500 dark:tw-text-blue-400'>
              {searchParams.get('error')}
            </p>
            <p className='tw-mt-4 tw-text-gray-500 dark:tw-text-gray-400'>
              <i>{searchParams.get('error_description')}</i>
            </p>
            <div className='tw-flex tw-items-center tw-mt-6 tw-gap-x-3'>
              <Link to='/login' className='error-page-back-btn'>
                Try Again
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className='tw-bg-white dark:tw-bg-gray-900'>
      <div className='tw-container tw-flex tw-items-center tw-min-h-screen tw-px-6 tw-py-12 tw-mx-auto tw-justify-center'>
        <Skeleton
          height={50}
          width={50}
          radius={'rounded'}
          className='eds-spacing--mr-16'
        />
        <Skeleton
          height={50}
          width={50}
          radius={'rounded'}
          className='eds-spacing--mr-16'
        />
        <Skeleton
          height={50}
          width={50}
          radius={'rounded'}
          className='eds-spacing--mr-16'
        />
      </div>
    </section>
  );
}
